module.exports = __webpack_public_path__ + "img/AG.dd82977f.svg";